import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { AbEntrySearchService } from './services/ab-entry-search.service';
import { InteractionsSearchService } from './services/interactions-search.service';
import { OpportunitiesSearchService } from './services/opportunities-search.service';
import { CasesSearchService } from './services/cases-search.service';
import { LeadSearchService } from './services/lead-search.service';

export function provideCoreGlobalSearchDataAccess(): EnvironmentProviders {
  return makeEnvironmentProviders([
    AbEntrySearchService,
    InteractionsSearchService,
    OpportunitiesSearchService,
    CasesSearchService,
    LeadSearchService,
  ]);
}
